import Axios from 'axios'
import commonA from './common'

Axios.defaults.headers.post['content-Type'] = 'application/x-www-form-urlencoded';
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
if (commonA.getQueryString().token) {
  Axios.defaults.headers.Authorization = `${commonA.getQueryString().token}`
}

let BASE_API;
if (process.env.NODE_ENV === 'production') {
  if (process.env.VUE_APP_FLAG === 'pro') {
    console.log('生产环境')
    BASE_API = 'https://api.91idu.com/api/'
  } else {
    //test 测试环境
    console.log('测试环境')
    BASE_API = 'https://testapi.91idu.com/api/';
  }
} else {
  //dev 开发环境
  console.log('开发环境')
    // BASE_API = 'https://api.91idu.com/api/'
    BASE_API = 'https://testapi.91idu.com/api/';
}

export default Axios.create({
  baseURL: BASE_API
});
